import React from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'
import NeptonApi from './NeptonApi'
import DimensionMap from '../dimensionMap/DimensionMap'

const Nepton = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()

  const items = [
    {
      label: t('integrationsPage:api'),
      key: 'api',
      children: <NeptonApi credentialsRequestUrl="/nepton/authentication/{companyId}" />
    },
    {
      label: t('global:costCentres'),
      key: 'dimensions',
      children: (
        <DimensionMap
          getDimensionsUrl="/nepton/dimensions/{companyId}"
          updateDimensionsUrl="/nepton/dimensions/{companyId}/{id}"
          dataKey="id"
        />
      )
    }
  ]

  return (
    <>
      <a href={integrationDocs.external('nepton')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Tabs items={items} destroyOnHidden />
    </>
  )
}

export default Nepton
